import Config from "./config";

$(function () {
    const timeout = Config.get('promotheusAppPopupTimeout');

    setTimeout(function () {
        showPopup();
    }, timeout);
});

function showPopup()
{
    // cookie klíč
    let leafletKey = 'promotheus-leaflet-show';
    
    // pokud není uložený klíč, dáme zobrazit popup
    if (getCookie(leafletKey) === 'showed')
    {
        return;
    }
        
    // pop up budeme otevírat pouze na androidu
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent))
    {
        // pokud nemáme id, nechceme spustit pop up a ukládat do cookie
        if (document.getElementById('modalAutoOpen-android') === null)
        {
            return;
        }

        // automatické otevření modálního okna pro systém android aplikaci promotheus
        $('#modalAutoOpen-android').modal('show');

        // do cookie uložím zobrazeno s platností 14 dní
        setCookie(leafletKey, 'showed', 14);

        // nastavíme event na proklík zobrazeného banneru
        $('#modalAutoOpen-android .google-play img').click(function() {
            gaPushPopup('click');
        });

        gaPushPopup('show');
    }

    // modální okno pro systém iOS
    if (/iPhone|iPod/i.test(userAgent))
    {
        // pokud nemáme id, nechceme spustit pop up a ukládat do cookie
        if (document.getElementById('modalAutoOpen-ios') === null)
        {
            return;
        }

        // automatické otevření modálního okna pro systém iOS aplikaci promotheus
        $('#modalAutoOpen-ios').modal('show');

        // do cookie uložím zobrazeno s platností 14 dní
        setCookie(leafletKey, 'showed', 14);

        // nastavíme event na proklík zobrazeného banneru
        $('#modalAutoOpen-ios .google-play img').click(function() {
            gaPushPopup('click');
        });

        gaPushPopup('show');
    }
}

// pushneme do GA
function gaPushPopup(type)
{
    gtag('event', 'Promotheus', {
        'event_category': 'Promotheus',
        'event_action': type,
        'event_label': 'Promotheus pop-up',
        'non_interaction': true
    });
}

// pro cookie
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}